import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

import { useBankProfile } from '../contexts/BankProfileContext';
import { useAuth } from './useAuth';

interface SingleStatementProps {
	statementId: string;
	accountId: string;
}

export interface SingleStatementDataProps {
	account_uuid: string;
	created_at: string;
	date_from: string;
	date_to: string;
	file_url: string;
	id: string;
	mime_type: string;
	original_name: string;
	status: string;
	type: string;
	updated_at: string;
}

const useStatement = ({ statementId, accountId }: SingleStatementProps) => {
	const { session } = useAuth();
	const { selectedProfile } = useBankProfile();

	const fetchStatement = async (): Promise<SingleStatementDataProps> => {
		const response = await axios.get(
			`${import.meta.env.VITE_API_HOST}/api/v1/profiles/${selectedProfile.id}/${accountId}/statement/${statementId}`,
			{
				headers: { Authorization: session?.tokenized },
			},
		);

		return response.data;
	};

	return useQuery({
		queryKey: ['single-statement', selectedProfile?.id, statementId],
		queryFn: fetchStatement,
		enabled: false,
		refetchOnWindowFocus: false,
	});
};

export { useStatement };
